export type OperationStatusBadgeType = "success" | "warning" | "error" | "neutral";

/** The dot colour of an operation or sequence status code: waiting or in progress is orange, ready or complete green, rejected red, Draft neutral. */
export const operationStatusBadgeType = (
  status: string | null | undefined,
): OperationStatusBadgeType => {
  switch (status) {
    case "SHIPPER_READY":
    case "COMPLETE":
      return "success";
    case "REJECTED":
      return "error";
    case "DRAFT":
    case undefined:
    case null:
      return "neutral";
    default:
      return "warning";
  }
};
